// extracted by mini-css-extract-plugin
export default {"doc-page-wrapper":"j_V container-lg d-flex p-3","doc-page":"j_W","doc-page__title--enterprise":"j_X","doc-page--with-side-menu":"j_Y","doc-page__title":"j_Z"};